import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/src/uncompressed/TweenMax';
import TimelineMax from 'gsap/src/uncompressed/TimelineMax';

import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-pattern4';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo pattern4');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        this.timeline = new TimelineMax();
        this.controller = new ScrollMagic.Controller();
        
        // Tasks on images
        setTimeout(() => { this.task1() },0); // poi sx
        setTimeout(() => { this.task2() },0); // prima l'immagine centrale
    }
    
    /**
     * Arriva da sx
     * @returns {undefined}
     */
    task1() {
        // Image 1
        let $target = this.$module.querySelector('.image1');
        
        if($target) {
        
            // translate attribute from styles
            let translateComputed = this.getTranslate($target);

            var tweenCaption = this.timeline
                .to($target, .4, {transform: "translateX(" + translateComputed.x + "px) translateY(" + translateComputed.y + "px)", opacity: 0, ease: Power4.easeInOut})
                .to($target, 3, {transform: "translateX(0) translateY(-50px)", opacity: 1, ease: Power4.easeOut});

            new ScrollMagic.Scene({
                triggerElement: this.$module,
                triggerHook:.8, // lo pinna quando è in alto (a 0)
                duration: "50%", // e lo tiene pinnato per la duration
                offset: 0
            })
            .setTween(tweenCaption)
            // .addIndicators({name: "Pattern1.1"}) // add indicators (requires plugin)
            .addTo(this.controller);
        }
    }
    
    /**
     * Arriva da dx
     * @returns {undefined}
     */
    task2() {
        // Image 2
        let $target = this.$module.querySelector('.image2');
        
        if($target) {

            // translate attribute from styles
            let translateComputed = this.getTranslate($target);

            var tweenCaption = this.timeline
                .to($target, .5, {transform: "translateX(" + translateComputed.x + "px) translateY(" + translateComputed.y + "px)", opacity: 0, ease: Power4.easeInOut})
                .to($target, 3, {transform: "translateX(0) translateY(50px)", opacity: 1, ease: Power4.easeOut});

            new ScrollMagic.Scene({
                triggerElement: this.$module,
                triggerHook:.8, // lo pinna quando è in alto (a 0)
                duration: "80%", // e lo tiene pinnato per la duration
                offset: 0
            })
            .setTween(tweenCaption)
            // .addIndicators({name: "Pattern1.2"}) // add indicators (requires plugin)
            .addTo(this.controller);
        }
    }

    // _________________________________________________________________________

    getTranslateX(el) {
        var style = window.getComputedStyle(el);
        var matrix = new WebKitCSSMatrix(style.webkitTransform);
        return matrix.m41;
    }

    // _________________________________________________________________________

    getTranslateY(el) {
        var style = window.getComputedStyle(el);
        var matrix = new WebKitCSSMatrix(style.webkitTransform);

        return matrix.m41;
    }
    
    // _________________________________________________________________________
    
    getTranslate(item) {
        var transArr = [];

        if (!window.getComputedStyle) return;
        var style     = getComputedStyle(item),
            transform = style.transform || style.webkitTransform || style.mozTransform || style.msTransform;
        var mat       = transform.match(/^matrix3d\((.+)\)$/);
        if (mat) return parseFloat(mat[1].split(', ')[13]);

        mat = transform.match(/^matrix\((.+)\)$/);
        mat ? transArr.push(parseFloat(mat[1].split(', ')[4])) : transArr.push(0);
        mat ? transArr.push(parseFloat(mat[1].split(', ')[5])) : transArr.push(0);
        
        transArr.x = transArr[0];
        transArr.y = transArr[1];

        return transArr;
    }

    // _________________________________________________________________________
    
    /**
     * Return current screen size
     * @returns {Int}
     */
    get_current_resolution() {
        return 'screen' in window && window.screen.width;
    }

    // _________________________________________________________________________
    
    /**
     * Return current window size
     * @returns {Int}
     */
    get_current_innerwidth() {
        var w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight|| e.clientHeight|| g.clientHeight;
    
        return x; 
    }
}

// export
export default new Module();